import { render } from "./list-cost.vue?vue&type=template&id=741faafb&scoped=true"
import script from "./list-cost.vue?vue&type=script&lang=js"
export * from "./list-cost.vue?vue&type=script&lang=js"

import "./list-cost.vue?vue&type=style&index=0&id=741faafb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741faafb"]])

export default __exports__